

import { FC } from 'react';
import { DropdownListItem, useToasts } from '@brg/ui';
import { createCopyLinkDesignerFn } from '../../helpers/copyLink';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CreateLinkTo } from '../../constants/linkTo';
import { useTheme } from 'styled-components';
import { AppTester } from 'supporting';
import styled from 'styled-components';

export interface DesignerTooltipProps {
    isEditable?: boolean;
    isTeamEditable?: boolean;
    identifier?: string;
    isReportable?: boolean;
    isHiddenCancel?: boolean;
    isCopyLink?: boolean;

    onCopyLink?: (designerId: string) => void;
    onEdit?: (designerId: string) => void;
    onReport?: (designerId: string) => void;
}
const DropdownListItemProfileEdit = styled(DropdownListItem)<{isGeograffee: boolean}>`
  ${(props) => props.isGeograffee && `
    background: #3F4548 !important;

    &:hover {
      background: #575B5E !important;
    }
  `}
`;

/**
 * **DesignerTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для проекта.
 * @param props
 */
export const DesignerTooltip: FC<React.PropsWithChildren<DesignerTooltipProps>> = (props) => {
    const { isReportable, isCopyLink, isHiddenCancel, isEditable, isTeamEditable, identifier, children, onReport, onEdit, onCopyLink } =
        props;
    const toasts = useToasts();
    const history = useHistory();
    const { t } = useTranslation();
    const isGeograffee = AppTester.isGeograffee()
    const isDafes = AppTester.isGeoDafes();
    const isBooksGallllery = AppTester.isBooksGallllery();

    const isDarkTheme =  (isGeograffee) && !isDafes;

    // Некоторые обработчики по умолчанию
    const copyLinkFn = onCopyLink ?? createCopyLinkDesignerFn(toasts, t);
    const editFn = onEdit ?? (() => history.push(CreateLinkTo.designerEdit(identifier ?? 'undefined')));
    const editTeamFn = () => history.push(`/team-edit/${identifier}`)
    const theme = useTheme();
    const fireEvent = (handler?: (s: string) => void) => () => handler?.(identifier ?? '');
    return (
        <>
            {/* @ts-ignore */}
            {isEditable && <DropdownListItemProfileEdit theming={!isDarkTheme && !isBooksGallllery && theme.navigationBar.login} isGeograffee={isDarkTheme} onClick={fireEvent(editFn)}>{t('edit').toLowerCase()}</DropdownListItemProfileEdit>}
            {isTeamEditable && <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(editTeamFn)}>{t('edit-team').toLowerCase()}</DropdownListItem>}
            {isReportable && (
                <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(onReport)}>{t('send_report').toLowerCase()}</DropdownListItem>
            )}
            {isCopyLink && (
                <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(copyLinkFn)}>{t('copy_link').toLowerCase()}</DropdownListItem>
            )}
            {children}
            {!isHiddenCancel && <DropdownListItem theming={theme.navigationBar.login}>{t('cancel').toLowerCase()}</DropdownListItem>}
        </>
    );
};


import { FC } from 'react';
import { DropdownListItem, useToasts } from '@brg/ui';
import { createCopyLinkDesignerFn } from '../../helpers/copyLink';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CreateLinkTo } from '../../constants/linkTo';
import { useTheme } from 'styled-components';
import { AppTester } from 'supporting';
import styled from 'styled-components';

export interface DesignerTooltipProps {
    isEditable?: boolean;
    isTeamEditable?: boolean;
    identifier?: string;
    isReportable?: boolean;
    isHiddenCancel?: boolean;
    isCopyLink?: boolean;

    onCopyLink?: (designerId: string) => void;
    onEdit?: (designerId: string) => void;
    onReport?: (designerId: string) => void;
}
const DropdownListItemProfileEdit = styled(DropdownListItem)<{isGeograffee: boolean}>`
  ${(props) => props.isGeograffee && `
    background: #3F4548 !important;

    &:hover {
      background: #575B5E !important;
    }
  `}
`;

/**
 * **DesignerTooltip** - контент всплывающего меню со всеми необходимыми параметрами и настройками для проекта.
 * @param props
 */
export const DesignerTooltip: FC<React.PropsWithChildren<DesignerTooltipProps>> = (props) => {
    const { isReportable, isCopyLink, isHiddenCancel, isEditable, isTeamEditable, identifier, children, onReport, onEdit, onCopyLink } =
        props;
    const toasts = useToasts();
    const history = useHistory();
    const { t } = useTranslation();
    const isGeograffee = AppTester.isGeograffee()
    const isDafes = AppTester.isGeoDafes();
    const isBooksGallllery = AppTester.isBooksGallllery();

    const isDarkTheme =  (isGeograffee) && !isDafes;

    // Некоторые обработчики по умолчанию
    const copyLinkFn = onCopyLink ?? createCopyLinkDesignerFn(toasts, t);
    const editFn = onEdit ?? (() => history.push(CreateLinkTo.designerEdit(identifier ?? 'undefined')));
    const editTeamFn = () => history.push(`/team-edit/${identifier}`)
    const theme = useTheme();
    const fireEvent = (handler?: (s: string) => void) => () => handler?.(identifier ?? '');
    return (
        <>
            {/* @ts-ignore */}
            {isEditable && <DropdownListItemProfileEdit theming={!isDarkTheme && !isBooksGallllery && theme.navigationBar.login} isGeograffee={isDarkTheme} onClick={fireEvent(editFn)}>{t('edit').toLowerCase()}</DropdownListItemProfileEdit>}
            {isTeamEditable && <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(editTeamFn)}>{t('edit-team').toLowerCase()}</DropdownListItem>}
            {isReportable && (
                <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(onReport)}>{t('send_report').toLowerCase()}</DropdownListItem>
            )}
            {isCopyLink && (
                <DropdownListItem theming={theme.navigationBar.login} onClick={fireEvent(copyLinkFn)}>{t('copy_link').toLowerCase()}</DropdownListItem>
            )}
            {children}
            {!isHiddenCancel && <DropdownListItem theming={theme.navigationBar.login}>{t('cancel').toLowerCase()}</DropdownListItem>}
        </>
    );
};
